"use client"

import { useState } from 'react'
import MoreButton from '../MoreButton'
import useT from '@hooks/useTranslation'

import styles from 'styles/OfferEquipment.module.css'

const Equipment = ({
    offer: { options },
    showCount = 10,
}) => {

    const [showAll, setShowAll] = useState(false)
    const t = {
        equip: useT('Wyposażenie'),
    }

    if (!options?.length) return null

    const allSeen = options.length <= showCount
    const allShowed = allSeen || showAll
    const viewableOptions = allShowed
        ? options
        : options.slice(0, showCount)

    return (
        <div>
            <aside className={styles.wrapper}>
                <h2 className={styles.h}>{t.equip}</h2>

                <div className={styles.opts}>
                    { viewableOptions.map(opt => <Option key={opt} opt={opt} />) }
                </div>

                {
                    !allShowed && <MoreButton onClick={() => setShowAll(true)} />
                }
            </aside>
        </div>
    )
}

function Option ({ opt }) {
    return opt
        ? <span className={styles.opt}>{opt}</span>
        : null
}

export default Equipment